import { Col } from 'reactstrap';
import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const Container = styled.div`

`;

export const FileNameContainer = styled.div`

`;

export const PDFContainer = styled.div `
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 60px;
`;

export const PDFIcon = styled.img `
    border-style: none;
    cursor: pointer;
    max-height: 50px;
`;

export const StyledCol = styled(Col)`
    padding: 0px;
`;

export const StyledLink = styled.a`
    color: ${ getTheme('primaryColor') };
    font-size: 12px;
    margin: 4px 0px 3px 10px;
`;
